
define('ui-helper/currency-helper',['jquery', 'knockout', 'eteration/eteration-ajax','eteration/ui/validation-helper', 'eteration/eteration-i18n' ],

function($, ko, etrAjax, validation, i18n) {
	

	
		var currencyList = [{
		      code : 'TRY',
  		      sign : '&#8378;',
  		      icon : 'cfa-try',
  		      side : true
  		},
  		{
  		      code : 'GBP',
  		      sign : '£',
  		      icon : 'cfa-gbp',
  		      side : true
  		},
  		{
		      code : 'BDT',
		      sign : 'BDT',
		      icon : 'cfa-bdt',
		      side : true
		},     		
  		{
			  code : 'BYR',
			  sign : 'BYR',
			  icon : 'cfa-byr',
			  side : true
  		},     		    		
  		{
  		      code : 'USD',
  		      sign : '$',
  		      icon : 'cfa-usd',
  		      side : true
  		},
  		{
  		      code : 'EUR',
  		      sign : '€',
  		      icon : 'cfa-eur',
  		      side : true
  		},
  		{
		      code : 'GEL',
		      sign : 'gel',
		      icon : 'cfa-gel',
		      side : true
		},      		
  		{
  		      code : 'JPY',
  		      sign : '¥',
  		      icon : 'cfa-jpy',
  		      side : true
  		},
  				
  		{
  		      code : 'RUB',
  		      sign : 'руб',
  		      icon : 'cfa-rub',
  		      side : true
  		},
  		
  		{
  		      code : 'KRW',
  		      sign : '₩',
  		      icon : 'cfa-krw',
  		      side : true
  		},
  		
  		{
  		      code : 'INR',
  		      sign : '',
  		      icon : 'cfa-inr',
  		      side : true
  		},
  		
  		{
  		      code : 'ILS',
  		      sign : '₪',
  		      icon : 'cfa-ils',
  		      side : true
  		},
  	
  		{
  		      code : 'MILE',
  		      sign : '',//mileSign,
  		      icon : '',
  		      side : false
  		},
  	  	
  		{
  		      code : 'MIL',
  		      sign : '',//mileSign,
  		      icon : '',
  		      side : false
  		},
  	  	
  		{
  		      code : 'PTS',
  		      sign : '',//mileSign,
  		      icon : '',
  		      side : false
  		},
  		{
  		      code : 'THB',
  		      sign : '฿',
  		      icon : 'cfa-thb',
  		      side : true
  		},
  		{
  		      code : 'AED',
  		      sign : 'د.إ',
  		      icon : 'cfa-aed',
  		      side : true
  		},
  		{
  		      code : 'AFN',
  		      sign : '؋',
  		      icon : 'cfa-afn',
  		      side : true
  		},
  		{
  		      code : 'AUD',
  		      sign : '$',
  		      icon : 'cfa-usd',
  		      side : true
  		},    		
  		{
  		      code : 'ALL',
  		      sign : 'Lek',
  		      icon : 'cfa-all',
  		      side : true
  		},	
  		{
  		      code : 'ARS',
  		      sign : '$',
  		      icon : 'cfa-usd',
  		      side : true
  		},
  		{
  		      code : 'AZE',
  		      sign : 'ман',
  		      icon : '',
  		      side : true
  		},
  		{
  		      code : 'AZN',
  		      sign : 'ман',
  		      icon : 'cfa-azn',
  		      side : true
  		},
  		{
  		      code : 'BAM',
  		      sign : 'KM',
  		      icon : 'cfa-bam',
  		      side : true
  		},
  		{
  		      code : 'BGN',
  		      sign : 'лв',
  		      icon : 'cfa-kgs',
  		      side : true
  		},
  		{
  		      code : 'BHD',
  		      sign : '.د.ب',
  		      icon : 'cfa-bhd',
  		      side : true
  		},      		
  		{
  		      code : 'BYR',
  		      sign : 'p.',
  		      icon : '',
  		      side : true
  		},	
  		{
  		      code : 'BRL',
  		      sign : 'R$',
  		      icon : 'cfa-brl',
  		      side : true
  		},
  		{
  		      code : 'CAD',
  		      sign : '$',
  		      icon : 'cfa-cad',
  		      side : true
  		},
  		{
		      code : 'CDF',
		      sign : 'CDF',
		      icon : 'cfa-cdf',
		      side : true
		}, 
  		{
  		      code : 'CFA',
  		      sign : 'CFA',
  		      icon : 'cfa-cfa',
  		      side : true
  		},     		
  		{
  		      code : 'CHF',
  		      sign : 'CHF',
  		      icon : 'cfa-chf',
  		      side : true
  		},
  		{
  		      code : 'CNY',
  		      sign : '¥',
  		      icon : 'cfa-cny',
  		      side : true
  		},
  		{
		      code : 'COP',
		      sign : 'COP',
		      icon : 'cfa-cop',
		      side : true
    	},           		
  		{
  		      code : 'CZK',
  		      sign : 'Kč',
  		      icon : 'cfa-czk',
  		      side : true
  		},
  		{
		      code : 'DJF',
		      sign : 'DJF',
		      icon : 'cfa-djf',
		      side : true
		},      		
  		{
  		      code : 'DKK',
  		      sign : 'kr',
  		      icon : 'cfa-dkk',
  		      side : true
  		},
  		{
  		      code : 'DZD',
  		      sign : 'دج',
  		      icon : 'cfa-dzd',
  		      side : true
  		},
  		{
  		      code : 'EGP',
  		      sign : '£',
  		      icon : 'cfa-egp',
  		      side : true
  		},  
  		{
		      code : 'ERN',
		      sign : 'ERN',
		      icon : 'cfa-ern',
		      side : true
		},   
  		{
  		      code : 'ETB',
  		      sign : 'ETB',
  		      icon : 'cfa-etb',
  		      side : true
  		},       		
  		{
  		      code : 'GHS',
  		      sign : 'GHS',
  		      icon : 'cfa-ghs',
  		      side : true
  		},
  		{
		      code : 'GNF',
		      sign : 'GNF',
		      icon : 'cfa-gnf',
		      side : true
		},   		
  		{
  		      code : 'HKD',
  		      sign : '$',
  		      icon : 'cfa-hkd',
  		      side : true
  		},
  		{
  		      code : 'HRK',
  		      sign : 'kn',
  		      icon : 'cfa-hrk',
  		      side : true
  		},
  		{
  		      code : 'HUF',
  		      sign : 'Ft',
  		      icon : 'cfa-huf',
  		      side : true
  		},
  		{
  		      code : 'IDR',
  		      sign : 'Rp',
  		      icon : 'cfa-idr',
  		      side : true
  		},
  		{
  		      code : 'IQD',
  		      sign : 'ع.د',
  		      icon : 'cfa-iqd',
  		      side : true
  		},
  		{
  		      code : 'IRR',
  		      sign : '﷼',
  		      icon : 'cfa-irr',
  		      side : true
  		},
  		{
  		      code : 'JOD',
  		      sign : 'ينار',
  		      icon : 'cfa-jod',
  		      side : true
  		},
  		{
		      code : 'KES',
		      sign : 'KES',
		      icon : 'cfa-kes',
		      side : true
		},
  		{
  		      code : 'KGS',
  		      sign : 'лв',
  		      icon : 'cfa-kgs',
  		      side : true
  		},
  		{
  		      code : 'KWD',
  		      sign : 'د.ك',
  		      icon : 'cfa-kwd',
  		      side : true
  		},
  		{
  		      code : 'KZT',
  		      sign : '',
  		      icon : 'cfa-kzt',
  		      side : true
  		},
  		{
  		      code : 'LBP',
  		      sign : 'LKR',
  		      icon : 'cfa-lbp',
  		      side : true
  		},
  		{
  		      code : 'LKR',
  		      sign : 'LKR',
  		      icon : 'cfa-lkr',
  		      side : true
  		},
  		{
		      code : 'LTL',
		      sign : 'LTL',
		      icon : 'cfa-ltl',
		      side : true
		},
  		{
  		      code : 'LVL',
  		      sign : 'LVL',
  		      icon : 'cfa-lvl',
  		      side : true
  		},    		
  		{
  		      code : 'LYD',
  		      sign : 'LD',
  		      icon : 'cfa-lyd',
  		      side : true
  		},
  		{
  		      code : 'MAD',
  		      sign : 'MAD',
  		      icon : 'cfa-mad',
  		      side : true
  		},
  		{
		      code : 'MDL',
		      sign : 'MDL',
		      icon : 'cfa-mdl',
		      side : true
		},
  		{
  		      code : 'MGF',
  		      sign : 'MGF',
  		      icon : 'cfa-mgf',
  		      side : true
  		},    		
  		{
  		      code : 'MKD',
  		      sign : 'MKD',
  		      icon : 'cfa-mkd',
  		      side : true
  		},   
  		{
		      code : 'MNT',
		      sign : 'MNT',
		      icon : 'cfa-mnt',
		      side : true
		},
  		{
  		      code : 'MRO',
  		      sign : 'MRO',
  		      icon : 'cfa-mro',
  		      side : true
  		},    
  		{
  		      code : 'MUR',
  		      sign : 'MUR',
  		      icon : 'cfa-mur',
  		      side : true
		},	
  		{
  		      code : 'MVR',
  		      sign : 'Rf',
  		      icon : 'cfa-mvr',
  		      side : true
  		},
  		{
  		      code : 'MYR',
  		      sign : 'RM',
  		      icon : 'cfa-myr',
  		      side : true
  		},
  		{
		      code : 'MZM',
		      sign : 'MZM',
		      icon : 'cfa-mzm',
		      side : true
		},
		{
		      code : 'TWD',
		      sign : 'TWD',
		      icon : 'cfa-twd',
		      side : true
		},
		
		
  		{
  		      code : 'NGN',
  		      sign : '₦',
  		      icon : 'cfa-ngn',
  		      side : true
  		},
  		{
  		      code : 'NOK',
  		      sign : 'kr',
  		      icon : 'cfa-nok',
  		      side : true
  		},
  		{
  		      code : 'NPR',
  		      sign : 'NPR',
  		      icon : 'cfa-npr',
  		      side : true
  		},
  		{
		      code : 'NZD',
		      sign : 'NZD',
		      icon : 'cfa-nzd',
		      side : true
		},      		
  		{
  		      code : 'OMR',
  		      sign : '﷼',
  		      icon : 'cfa-omr',
  		      side : true
  		},
  		{
  		      code : 'PKR',
  		      sign : '₨',
  		      icon : 'cfa-pkr',
  		      side : true
  		},
  		{
  		      code : 'PLN',
  		      sign : 'zł',
  		      icon : 'cfa-pln',
  		      side : true
  		},
  		{
  		      code : 'QAR',
  		      sign : '﷼',
  		      icon : 'cfa-qar',
  		      side : true
  		},		                      		
  		{
      			code : 'RGP',
      			sign : '£',
      			icon : 'cfa-rgp',
      			side : true
  		},      		
  		{
  		      code : 'RON',
  		      sign : 'lei',
  		      icon : 'cfa-ron',
  		      side : true
  		},
  		{
  		      code : 'RSD',
  		      sign : 'Дин.',
  		      icon : 'cfa-rsd',
  		      side : true
  		},
  		{
		      code : 'RWF',
		      sign : 'RWF',
		      icon : 'cfa-rwf',
		      side : true
		},      		
  		{
  		      code : 'SAR',
  		      sign : '﷼',
  		      icon : 'cfa-sar',
  		      side : true
  		},
  		{
  		      code : 'SEK',
  		      sign : 'kr',
  		      icon : 'cfa-sek',
  		      side : true
  		},
  		{
		      code : 'SDG',
		      sign : 'SDG',
		      icon : 'cfa-sdg',
		      side : true
		},
  		{
  		      code : 'SGD',
  		      sign : 'SGD',
  		      icon : 'cfa-sgd',
  		      side : true
  		},
  		{
		      code : 'SOS',
		      sign : 'SOS',
		      icon : 'cfa-sos',
		      side : true
		},      		
  		{
  		      code : 'SSP',
  		      sign : 'SSP',
  		      icon : 'cfa-ssp',
  		      side : true
  		},      		
  		{
		      code : 'SYP',
		      sign : 'SYP',
		      icon : 'cfa-syp',
		      side : true
  		},      		  		
  		{
  		      code : 'TMT',
  		      sign : 'T',
  		      icon : 'cfa-tmt',
  		      side : true
  		},
  		{
  		      code : 'TND',
  		      sign : 'د.ت',
  		      icon : 'cfa-tnd',
  		      side : true
  		},
  		{
  		      code : 'TJS',
  		      sign : 'TJS',
  		      icon : 'cfa-tjs',
  		      side : true
  		}, 
  		{
		      code : 'TZS',
		      sign : 'TZS',
		      icon : 'cfa-tzs',
		      side : true
		},      		
  		{
  		      code : 'UAH',
  		      sign : '₴',
  		      icon : 'cfa-uah',
  		      side : true
  		},
  		{
		      code : 'UGX',
		      sign : 'UGX',
		      icon : 'cfa-ugx',
		      side : true
		},      		
  		{
  		      code : 'UZS',
  		      sign : 'лв',
  		      icon : 'cfa-uzs',
  		      side : true
  		},
  		{
  		      code : 'VND',
  		      sign : '₫',
  		      icon : 'cfa-vnd',
  		      side : true
  		},      		
  		{
		      code : 'XAF',
		      sign : 'XAF',
		      icon : 'cfa-xaf',
		      side : true
		},      		      		
  		{
  		      code : 'XOF',
  		      sign : 'XOF',
  		      icon : 'cfa-xof',
  		      side : true
  		},      		      		
		{
  		      code : 'YER',
  		      sign : '﷼',
  		      icon : 'cfa-yer',
  		      side : true
  		},
  		{
  		      code : 'ZAR',
  		      sign : 'R',
  		      icon : 'cfa-zar',
  		      side : true
  		},
  		{
		      code : 'ZMW',
		      sign : 'ZMW',
		      icon : 'cfa-zmw',
		      side : true
		}
  		,
  		{
		      code : 'TWD',
		      sign : 'NT$',
		      icon : 'cfa-twd',
		      side : true
		}
  		,
  		{
		      code : 'PHP',
		      sign : '₱₱',
		      icon : 'cfa-php',
		      side : true
		},
  		{
		      code : 'MZN',
		      sign : 'MT',
		      icon : 'cfa-php',
		      side : true
		},
  		{
		      code : 'PAB',
		      sign : '﷼',
		      icon : 'cfa-pab',
		      side : true
		}
  		];
	

		return {
			currencyList : currencyList
		};

});


